import { render, staticRenderFns } from "./TurmasBolsaFamilia.vue?vue&type=template&id=80f5f854"
import script from "./TurmasBolsaFamilia.vue?vue&type=script&lang=js"
export * from "./TurmasBolsaFamilia.vue?vue&type=script&lang=js"
import style0 from "./TurmasBolsaFamilia.vue?vue&type=style&index=0&id=80f5f854&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports